import { render, staticRenderFns } from "./PlanShow.vue?vue&type=template&id=c07f16e2&"
import script from "./PlanShow.vue?vue&type=script&lang=js&"
export * from "./PlanShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports